import { http } from "../lib/http";

export async function fetchProfile(orgId) {
  return await http.get(`/fe/profile/${orgId}`);
}

export async function updateProfile(orgId, data) {
  return await http.put(`/fe/profile/${orgId}`, data);
}
